// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"3505":"7aeec5c9","6294":"0af98a8b"}[chunkId] || chunkId) + "." + {"1883":"7800863853e12d67","2327":"e847659a8bb620b2","3065":"6e2aa5aa2061dcc4","3505":"c2667aaabea2005b","6294":"a0fd4754801c340d","9210":"0cf33289116fe86e"}[chunkId] + ".js";
};